import React from 'react';
import Stack from '@mui/material/Stack';
import MUIDataTable, { MUIDataTableColumnDef, MUIDataTableCustomHeadRenderer, MUIDataTableOptions, MUISortOptions } from "mui-datatables"
import { useState, useEffect } from 'react';

import Tooltip from '@mui/material/Tooltip'
import Button from '@mui/material/Button'
import { SocketContext } from '../contexts/socket';
import Divider from '@mui/material/Divider';
import ImageSearchIcon from '@mui/icons-material/ImageSearch';
import IconButton from '@mui/material/IconButton';
import DownloadIcon from '@mui/icons-material/Download';
import { useAuth } from '../contexts/AuthContext';
import { useISUContext } from '../pages/Gui/gui';

import { Container } from '@mui/material';
import downloadAnimation from './downloading.gif';

interface Props {
  filterModel: {
    items?: [] 
  },
  loading: boolean,
  disabled: boolean
}

export function WgetButton(props: Props) {
  const tableFilters = props.filterModel;
  const { token } = useAuth();
  const isu = useISUContext();
  const socket = React.useContext(SocketContext);
  const [wgetDownloadStatus, setWgetDownloadStatus] = useState({ "status": "complete" });
  const [enableWgetButton, setEnableWgetButton] = useState(true);

  useEffect( () => {
     if ( tableFilters ) {
          const items_ = tableFilters.items;//[0] || [''];
            // if ( items_[0]['value'] == "" ) {
             //   // Disable Wget Button
              //  setEnableWgetButton(false)
            // }
     }
  }, [])


  const handleScriptDownload = () => {
    if (token) {
      setWgetDownloadStatus({ 'status': 'inprogress' });
      setEnableWgetButton(false);
      socket.emit('request_wget', token, [isu.downloadFilenames, tableFilters])
      socket.once('wget_delivery_complete', (wget_status: any) => {
        setWgetDownloadStatus({ 'status': 'complete' });
        setEnableWgetButton(true);
      });
    }
  }
  return (
    <React.Fragment>
      <Tooltip title={'Press to download wget script'} className="no-print">
        <span>
          <Button variant={'contained'} size='small' disabled={ !enableWgetButton || props.loading || props.disabled } onClick={handleScriptDownload}>
            {(wgetDownloadStatus.status == "inprogress") ? (<div style={{ height: '2em', display: 'flex' }}>
              <span style={{ lineHeight: '2em' }}>Download In Progress</span>
              <img src={downloadAnimation} style={{ height: '100%', marginLeft: '1em', padding: '.2em', borderRadius: '50%' }} /></div>) : (<div style={{ height: '2em', display: 'flex' }}><span style={{ lineHeight: '2em' }}>Download Wget Script(s)</span></div>
              )}
          </Button>
        </span>
      </Tooltip>
    </React.Fragment>
  );
}

export default WgetButton 
